<div style="max-width: 90vw">
  <div mat-dialog-title>
    <h5 i18n>Convert Quote</h5>
  </div>
  <p *ngIf="!isMobile" i18n>Convert Quote to Job</p>

  <div mat-dialog-content style="margin: 0">
    <form #upgradeForm="ngForm" (ngSubmit)="convertQuote(upgradeForm)">
      <div class="form-group row">
        <div class="col-sm-12 form-inline">
          <div class="control-wrapper">
            <label for="paymentType_ID" class="col-form-label">
              <span class="warning">* </span>
              <span i18n>Payment Type</span>
            </label>
            <select name="quote_PaymentType_ID" id="quote_PaymentType_ID" class="form-control"
                    required
                    [(ngModel)]="quote.quote_PaymentType_ID" #quote_PaymentType_ID="ngModel">

              <option [ngValue]="undefined">-</option>
              <option *ngFor="let paymentType of paymentTypes" [ngValue]="paymentType.paymentType_ID">{{paymentType.paymentType_Desc}}</option>
            </select>
          </div>
          <div class="control-wrapper">
            <label for="paymentTerm_ID" class="col-form-label">
              <span class="warning">* </span>
              <span i18n>Payment Terms</span>
            </label>
            <select name="quote_PaymentTerm_ID" id="quote_PaymentTerm_ID" class="form-control"
                    required
                    [(ngModel)]="quote.quote_PaymentTerm_ID" #quote_PaymentTerm_ID="ngModel">

              <option [ngValue]="undefined">-</option>
              <option *ngFor="let paymentTerm of paymentTerms" [ngValue]="paymentTerm.paymentTerm_ID">{{paymentTerm.paymentTerm_Desc}}</option>
            </select>
          </div>
        </div>
      </div>
      <div [hidden]="!upgradeForm.submitted || quote_PaymentType_ID.valid"
           class="alert alert-danger" i18n>
        Payment Type Required
      </div>
      <div [hidden]="!upgradeForm.submitted || quote_PaymentTerm_ID.valid"
           class="alert alert-danger" i18n>
        Payment Term Required
      </div>

      <div *ngIf="upgradeAreaSummaries.length==0" class="col-12">
        <h6 i18n>No alternates or options available.</h6>
      </div>

      <div *ngIf="isMobile" class="mobile">
        <div class="text-bidit-primary" *ngFor="let area of upgradeAreaSummaries">
          <div *ngIf="!area.area_IsOption">
            <h5>{{area.area_Name}}</h5>
            <div *ngFor="let lineItem of area.quoteAreas">
              <div class="card border-bidit-dark">
                <div class="card-body">
                  <div *ngIf="lineItem.quoteItem.area_Name" class="text-bidit-primary-header " id="lineItem.quoteItem.area_Name">{{lineItem.quoteItem.area_Name}}</div>
                  <div *ngIf="!lineItem.quoteItem.area_Name" class="text-bidit-primary-header " id="lineItem.quoteItem.subArea.subArea_Name">{{lineItem.quoteItem.subArea.subArea_Name}}</div>
                  <div class="col">
                    <span *ngIf="lineItem.quoteItem.item?.item_Part"><span i18n>Product:</span> {{lineItem.quoteItem.item.item_Part}}, </span>
                    {{lineItem.quoteItem.item?.item_Name}}
                    <div class="mt-2">
                      <div *ngIf="lineItem.quoteItem.rValue" class="col">
                        <label class="mr-2" i18n>R-Value:</label>
                        <span>
                          {{lineItem.quoteItem.rValue.rValue_Desc}}
                        </span>
                      </div>
                      <div>
                        <label i18n>Sqr Ftg:</label>
                        <span>{{lineItem.quoteItem.area_SqrFtg}}</span>
                      </div>
                    </div>
                    <mat-radio-group name="area_IsAccepted{{lineItem.quoteArea_ID}}"
                                     [(ngModel)]="lineItem.area_RadioValue" #area_RadioValue="ngModel"
                                     (change)="calculateConversion()">
                      <mat-radio-button [value]="lineItem.quoteItem.quoteAreaItem_ID"></mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <div *ngFor="let upgrade of lineItem.quoteUpgrades">
                    <span *ngIf="upgrade.item.item_Part"><span i18n>Product:</span> {{upgrade.item.item_Part}}, </span>
                    {{upgrade.item.item_Name}}
                    <div>
                      <label class="mr-2">R-Value: </label>
                      <span *ngIf="upgrade.item.rValue">{{upgrade.item.rValue.rValue_Desc}}</span>
                      <span class="ml-2" *ngIf="upgrade.itemUsage"><span i18n>Alternate:</span> {{upgrade.itemUsage.rValue.rValue_Desc}}</span>
                    </div>
                    <div class="col">
                      <span class="float-right"><strong i18n>Estimate Change:</strong> ${{upgrade.upgradeBid | number: '1.2-2'}}</span><br>
                      <span class="float-right"><strong i18n>Cost Change:</strong> ${{upgrade.upgradeDelta | number: '1.2-2'}}</span>
                    </div>
                    <div class="col">
                      <mat-radio-group name="area_IsAccepted{{lineItem.quoteArea_ID}}"
                                       [(ngModel)]="lineItem.area_RadioValue" #area_RadioValue="ngModel"
                                       (change)="calculateConversion()">
                        <mat-radio-button [value]="upgrade.quoteAreaItem_ID"></mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="area.area_IsOption">
            <div *ngFor="let areaOptionGroup of area.quoteAreaOptionGroups">
              <span *ngIf="areaOptionGroup.optionGroup === null; then ungroupedOptionBlock; else groupOptionBlock"></span>
              <ng-template #groupOptionBlock>
                <h5>{{area.area_Name}} - Group {{areaOptionGroup.optionGroup}}</h5>
                <mat-radio-group class="form-inline" name="area_IsAccepted{{areaOptionGroup.optionGroup}}"
                                 [(ngModel)]="areaOptionGroup.group_radioValue" #area_RadioValue="ngModel"
                                 (change)="setOptionGroupSelected(areaOptionGroup.optionGroup, areaOptionGroup.group_radioValue )">
                  <mat-radio-button [value]="1" i18n>Accept</mat-radio-button><br />
                  <mat-radio-button [value]="0" i18n>Decline</mat-radio-button>
                </mat-radio-group>
              </ng-template>

              <ng-template #ungroupedOptionBlock>
                <h5 class="mb-0">
                  {{area.area_Name}}
                </h5>
              </ng-template>
              <div *ngFor="let lineItem of areaOptionGroup.quoteAreaItems">
                <div class="card border-bidit-dark">
                  <div class="card-body">
                    <div *ngIf="lineItem.area_Name" class="text-bidit-primary-header" id="lineItem.area_Name">{{lineItem.area_Name}}</div>
                    <div *ngIf="!lineItem.area_Name" class="text-bidit-primary-header" id="lineItem.subArea.subArea_Name">{{lineItem.subArea.subArea_Name}}</div>
                    <div class="col">
                      <div *ngIf="lineItem.item">
                        <span *ngIf="lineItem.item?.item_Part"><span i18n>Product:</span> {{lineItem.item.item_Part}}, </span>
                        {{lineItem.item.item_Name}}
                      </div>
                      <div class="mt-2">
                        <div *ngIf="lineItem.rValue" class="col">
                          <label class="mr-2" i18n>R-Value:</label>
                          <span>
                            {{lineItem.rValue.rValue_Desc}}
                          </span>
                        </div>
                        <div>
                          <label i18n>Sqr Ftg:</label>
                          <span>{{lineItem.qarea_SqrFtg}}</span>
                        </div>
                      </div>
                      <mat-radio-group *ngIf="areaOptionGroup.optionGroup === null" name="area_IsAccepted{{lineItem.quoteArea_ID}}"
                                       [(ngModel)]="lineItem.area_RadioValue" #area_RadioValue="ngModel"
                                       (change)="setOptionSelected(lineItem.quoteAreaItem_ID, lineItem.area_IsAccepted)">
                        <mat-radio-button [value]="lineItem.quoteAreaItem_ID" i18n>Accept</mat-radio-button>
                        <mat-radio-button [value]="0" i18n>Decline</mat-radio-button>
                      </mat-radio-group>
                      <span class="float-right"><strong i18n>Estimate Change:</strong> ${{lineItem.ptionBid | number:'1.2-2'}}</span><br>
                      <span class="float-right"><strong i18n>Cost Change:</strong> ${{lineItem.area_TotalCost | number: '1.2-2'}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!isMobile">
        <div *ngFor="let area of upgradeAreaSummaries">
          <div *ngIf="!area.area_IsOption">
            <h5>{{area.area_Name}}</h5>
            <div *ngFor="let lineItem of area.quoteAreas">
              <table class="table" width="100%">
                <thead>
                  <tr>
                    <th i18n>Accepted</th>
                    <th>Name</th>
                    <th i18n>R-Value</th>
                    <th i18n>Product</th>
                    <th i18n>Sqr Ftg</th>
                    <th><span class="float-right" i18n>Estimate Change</span></th>
                    <th><span class="float-right" i18n>Cost Change</span></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center">
                      <mat-radio-group name="area_IsAccepted{{lineItem.quoteArea_ID}}"
                                       [(ngModel)]="lineItem.area_RadioValue" #area_RadioValue="ngModel"
                                       (change)="calculateConversion()">
                        <mat-radio-button [value]="lineItem.quoteItem.quoteAreaItem_ID"></mat-radio-button>
                      </mat-radio-group>
                    </td>
                    <td>
                      <span *ngIf="lineItem.quoteItem.area_Name">{{lineItem.quoteItem.area_Name}}</span>
                      <span *ngIf="!lineItem.quoteItem.area_Name">{{lineItem.quoteItem.subArea.subArea_Name}}</span>
                    </td>
                    <td>
                      <span *ngIf="lineItem.quoteItem.itemUsage; then usageBlock; else rValueBlock"></span>
                      <ng-template #usageBlock>{{lineItem.quoteItem.itemUsage.rValue.rValue_Desc}}</ng-template>
                      <ng-template #rValueBlock>
                        <span *ngIf="lineItem.quoteItem.item && lineItem.quoteItem.item.rValue">{{lineItem.quoteItem.item.rValue.rValue_Desc}}</span>
                      </ng-template>
                    </td>
                    <td>
                      <div *ngIf="lineItem.quoteItem.item">
                        <span *ngIf="lineItem.quoteItem.item.item_Part">{{lineItem.quoteItem.item.item_Part}}, </span>
                        {{lineItem.quoteItem.item.item_Name}}
                      </div>
                    </td>
                    <td>
                      {{lineItem.quoteItem.area_SqrFtg}}
                    </td>
                    <td *ngIf="area.area_IsOption">
                      <span class="float-right">${{lineItem.quoteItem.optionBid | number:'1.2-2'}}</span>
                    </td>
                    <td *ngIf="area.area_IsOption">
                      <span class="float-right">${{lineItem.quoteItem.area_TotalCost | number: '1.2-2'}}</span>
                    </td>
                  </tr>
                  <tr *ngFor="let upgrade of lineItem.quoteUpgrades">
                    <td align="center">
                      <mat-radio-group name="area_IsAccepted{{lineItem.quoteArea_ID}}"
                                       [(ngModel)]="lineItem.area_RadioValue" #area_RadioValue="ngModel"
                                       (change)="calculateConversion()">
                        <mat-radio-button [value]="upgrade.quoteAreaItem_ID"></mat-radio-button>
                      </mat-radio-group>
                    </td>
                    <td>
                      <strong i18n>ALTERNATE:</strong>
                    </td>
                    <td>
                      <span *ngIf="upgrade.itemUsage; then usageBlock; else rValueBlock"></span>
                      <ng-template #usageBlock>{{upgrade.itemUsage.rValue.rValue_Desc}}</ng-template>
                      <ng-template #rValueBlock>{{upgrade.item.rValue.rValue_Desc}}</ng-template>
                    </td>
                    <td>
                      <span *ngIf="upgrade.item.item_Part">{{upgrade.item.item_Part}}, </span>
                      {{upgrade.item.item_Name}}
                    </td>
                    <td>{{upgrade.area_SqrFtg}}</td>
                    <td>
                      ${{upgrade.upgradeBid | number: '1.2-2'}}
                    </td>
                    <td>
                      ${{upgrade.upgradeDelta | number: '1.2-2'}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div *ngIf="area.area_IsOption">
            <div *ngFor="let areaOptionGroup of area.quoteAreaOptionGroups">
              <span *ngIf="areaOptionGroup.optionGroup === null; then ungroupedOptionBlock; else groupOptionBlock"></span>
              <ng-template #ungroupedOptionBlock>
                <h5 class="mb-0">
                  {{area.area_Name}}
                </h5>
              </ng-template>
              <ng-template #groupOptionBlock>
                <h5>{{area.area_Name}} - Group {{areaOptionGroup.optionGroup}}</h5>
                <mat-radio-group class="form-inline" name="area_IsAccepted{{areaOptionGroup.optionGroup}}"
                                 [(ngModel)]="areaOptionGroup.group_radioValue" #group_radioValue="ngModel"
                                 (change)="setOptionGroupSelected(areaOptionGroup.optionGroup, areaOptionGroup.group_radioValue )">
                  <mat-radio-button [value]="1" i18n>Accept</mat-radio-button><br />
                  <mat-radio-button [value]="0" i18n>Decline</mat-radio-button>
                </mat-radio-group>
              </ng-template>

              <table class="table" width="100%">
                <thead>
                  <tr>
                    <th *ngIf="areaOptionGroup.optionGroup === null">
                    </th>
                    <th i18n>Name</th>
                    <th i18n>R-Value</th>
                    <th i18n>Product</th>
                    <th i18n>Sqr Ftg</th>
                    <th><span class="float-right" i18n>Estimate Change</span></th>
                    <th><span class="float-right" i18n>Cost Change</span></th>
                  </tr>
                </thead>
                <tbody>
                  <ng-template ngFor let-lineItem [ngForOf]=" areaOptionGroup.quoteAreaItems">
                    <tr>
                      <td align="center" *ngIf="areaOptionGroup.optionGroup === null">
                        <mat-radio-group name="area_IsAccepted{{lineItem.quoteArea_ID}}"
                                         [(ngModel)]="lineItem.area_IsAccepted" #lineItem.area_IsAccepted="ngModel"
                                         (change)="setOptionSelected(lineItem.quoteAreaItem_ID, lineItem.area_IsAccepted)">
                          <mat-radio-button [value]="true" i18n>Accept</mat-radio-button><br />
                          <mat-radio-button [value]="false" i18n>Decline</mat-radio-button>
                        </mat-radio-group>
                      </td>
                      <td>
                        <span *ngIf="lineItem.area_Name">{{lineItem.area_Name}}</span>
                        <span *ngIf="!lineItem.area_Name">{{lineItem.subArea.subArea_Name}}</span>
                      </td>
                      <td>
                        <span *ngIf="lineItem.itemUsage; then usageBlock; else rValueBlock"></span>
                        <ng-template #usageBlock>{{lineItem.itemUsage.rValue.rValue_Desc}}</ng-template>
                        <ng-template #rValueBlock>
                          <span *ngIf="lineItem.item && lineItem.item.rValue">{{lineItem.item.rValue.rValue_Desc}}</span>
                        </ng-template>
                      </td>
                      <td>
                        <div *ngIf="lineItem.item">
                          <span *ngIf="lineItem.item.item_Part">{{lineItem.item.item_Part}}, </span>
                          {{lineItem.item.item_Name}}
                        </div>
                      </td>
                      <td>
                        {{lineItem.area_SqrFtg}}
                      </td>
                      <td>
                        <span class="float-right">${{lineItem.optionBid | number:'1.2-2'}}</span>
                      </td>
                      <td>
                        <span class="float-right">${{lineItem.area_TotalCost | number: '1.2-2'}}</span>
                      </td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="estimate-pnl">
        <h5 align="center" i18n>ESTIMATE</h5>
        <table class="table table-bidit">
          <tbody>
            <tr *ngIf="showMargins">
              <td i18n>Total Cost:</td>
              <td>${{quote.totalCost + quote.optionCost | number: '1.2'}}</td>
            </tr>
            <tr *ngIf="showMargins" >
              <td i18n >Gross Margin:</td>
              <td>
                <div *ngIf="showMarginEdit; else marginView" class="form-group" id="showMargin">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <button class="btn btn-outline-danger form-control" (click)="updateConvertMargin()" i18n>Calculate</button>
                    </div>
                    <input name="quote_GrossMargin" type="number" id="quote_GrossMargin" class="form-control"
                           style="text-align: right;"
                           [(ngModel)]="quote.quote_GrossMargin" #quote_GrossMargin="ngModel" />
                  </div>
                </div>
                <ng-template #marginView>
                  <div>
                    <a class="float-left" href="javascript:void(0);" (click)="editMargin()" i18n>Edit</a>
                    <span class="float-right">{{quote.quote_GrossMargin | number: '1.0-4'}}%</span>
                  </div>
                </ng-template>
              </td>
            </tr>
            <tr *ngIf="showMargins">
              <td i18n>Bid Amount:</td>
              <td>
                <div *ngIf="showBidAmountEdit; else bidAmountView" class="form-group" id="show">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <button class="btn btn-outline-danger form-control" (click)="updateConvertBid()" i18n>Calculate</button>
                    </div>
                    <input name="quote_BidAmount" type="number" id="quote_BidAmount" class="form-control"
                           style="text-align: right;"
                           [(ngModel)]="quote.quote_BidAmount" #quote_BidAmount="ngModel">
                  </div>
                </div>
                <ng-template #bidAmountView>
                  <div>
                    <a href="javascript:void(0);" (click)="editBid()" i18n>Edit</a>
                    <span class="float-right">${{quote.quote_BidAmount | number: '1.2-2'}}</span>
                  </div>
                </ng-template>
              </td>
            </tr>
            <tr  *ngIf="showMargins">
              <td i18n>Margin Dollars:</td>
              <td>${{this.totalMarginDollars | number: '1.2-2'}}</td>
            </tr>
            <tr>
              <td>
                <label i18n>Tax Amount:</label>
              </td>
              <td>${{this.netTaxTotal | number: '1.2-2'}}</td>
            </tr>
            <tr>
              <td i18n>Total Bid Amount:</td>
              <td>${{this.quoteTotalBidAmount | number: '1.2-2'}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div [hidden]="!upgradeForm.submitted || upgradeForm.valid"
           class="alert alert-danger" i18n>
        Validation issues encountered.  Please review your entered information.
      </div>
      <div class="row">
        <div class="col-sm-4"></div>
        <div class="col-sm-8">
          <button type="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
          <button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
        </div>
      </div>
    </form>
  </div>
</div>
